import React from 'react';
import fr from 'facet-rest';
import { FDStack, tokens } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';
import { PrimaryActionButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/PrimaryActionButtonRel';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { dataAttrs } from 'Helpers/Testing';

const useStyles = buildUseStyles('AccountOpeningV2FinishStepTemplate', () => ({
  lottie: {
    // Deal with the fact that this lottie has the wrong background color
    '& rect': {
      fill: tokens.color_oceana_800,
    },
  },
}));

export const AccountOpeningV2FinishStepLayout = () => {
  const { resource } = useMetaLayoutContext();
  const classes = useStyles();
  return (
    <FDStack spacing={3} direction="column" {...dataAttrs('celebration-background', resource)}>
      <div className={classes.lottie}>
        <LottieRel relationship={resource.relationship(fr.relationships.lottie.name)} />
      </div>
      <MetaControlField attr="title" />
      <MetaControlField attr="description" />
      <MetaLayoutRemainingFields noAccordion />
      <FDStack direction="column" alignItems="center" spacing={2}>
        <PrimaryActionButtonRel
          relationship={resource.relationship(fr.relationships.homePage.name)}
          {...dataAttrs('continue-btn', resource)}
        />
      </FDStack>
    </FDStack>
  );
};
